"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openPuzzleDatabase = openPuzzleDatabase;
exports.saveCollection = saveCollection;
exports.imageBlob = imageBlob;
exports.loadCollection = loadCollection;
exports.createPictureId = createPictureId;
const LEGACY_KEY = 'balloons.puzzles.v1';
function openPuzzleDatabase() {
    return new Promise((resolve, reject) => {
        let blocked = false;
        const request = indexedDB.open('balloons-puzzles', 1);
        request.onupgradeneeded = () => request.result.createObjectStore('state');
        request.onsuccess = () => {
            const db = request.result;
            if (blocked) {
                db.close();
                return;
            }
            db.onversionchange = () => db.close();
            resolve(db);
        };
        request.onerror = () => reject(request.error);
        request.onblocked = () => { blocked = true; reject(new Error('Close other puzzle tabs and try again.')); };
    });
}
async function transaction(mode, action) {
    const db = await openPuzzleDatabase();
    try {
        return await new Promise((resolve, reject) => {
            const tx = db.transaction('state', mode);
            const request = action(tx.objectStore('state'));
            tx.oncomplete = () => resolve(request.result);
            tx.onabort = () => reject(tx.error ?? new Error('Puzzle storage was interrupted.'));
            tx.onerror = () => reject(tx.error);
        });
    }
    finally {
        db.close();
    }
}
async function saveCollection(collection) {
    await transaction('readwrite', store => store.put(collection, 'collection'));
}
function imageBlob(value) {
    if (typeof value !== 'string' || value.length > 3_000_000 || !/^data:image\/(png|jpeg|webp);base64,/.test(value))
        throw new Error('Invalid image');
    const [header, data] = value.split(',');
    const bytes = Uint8Array.from(atob(data), c => c.charCodeAt(0));
    return new Blob([bytes], { type: header.slice(5, header.indexOf(';')) });
}
async function loadCollection() {
    const existing = await transaction('readonly', store => store.get('collection'));
    if (existing)
        return existing;
    let legacy = null;
    try {
        legacy = localStorage.getItem(LEGACY_KEY);
    }
    catch { /* No legacy storage. */ }
    const empty = { pictures: [], size: 3, preview: false };
    if (!legacy)
        return empty;
    let migrated;
    try {
        const parsed = JSON.parse(legacy);
        migrated = { pictures: parsed.pictures.slice(0, 20).map((p, index) => ({
                id: `legacy-${index}`, name: String(p.name).slice(0, 200), blob: imageBlob(p.image)
            })), size: [3, 4, 5].includes(parsed.size) ? parsed.size : 3, preview: false };
    }
    catch {
        return empty;
    }
    await saveCollection(migrated);
    // Remove the old image data only after the IndexedDB transaction commits.
    try {
        localStorage.removeItem(LEGACY_KEY);
    }
    catch { /* Migration is already durable. */ }
    return migrated;
}
/** IDs also work on local kiosk HTTP pages where randomUUID is unavailable. */
function createPictureId() {
    return globalThis.crypto?.randomUUID?.() ?? `picture-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}
//# sourceMappingURL=storage.js.map